import React from 'react';
import styled from '@emotion/styled';
import Img from '../../../components/Img/Img';

const ForgotPasswordSuccess = () => {
  return (
    <Container>
      <div>
        <Img src="/static/img/suss.png" />
      </div>
      <div>
        <div>
          <h3>Password reset link sent</h3>
          <p>
            A password reset link has been successfully sent to your email
            address
          </p>
        </div>
      </div>
    </Container>
  );
};

const Container = styled.div`
  box-shadow: 0px 20px 26px 0px #bab6b629;
  margin-top: 5rem;
  width: 723px;
  height: 529px;
  top: 199px;
  left: 358px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  border-radius: 12px;

  @media (max-width: 480px) {
    box-shadow: none;
  }

  & > div:nth-of-type(1) {
    width: 100px;
    height: fit-content;
  }

  & > div {
    display: flex;
    flex-direction: column-reverse;
    & > div {
      width: 368px;
      height: 110px;
      & > h3 {
        color: ${({ theme }) => theme.palette.blackBlack2};
        font-size: 32px;
        font-weight: 500;
        line-height: 47.84px;
        letter-spacing: -0.02em;
        text-align: center;
      }
      & > p {
        color: ${({ theme }) => theme.palette.blackBlack3};
        font-size: 20px;
        font-weight: 400;
        line-height: 29.9px;
        letter-spacing: -0.02em;
        text-align: center;
      }
    }
  }
`;

export default ForgotPasswordSuccess;
